import React from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../components";
import AllClients from "./Clients/AllClients";
import ClientsWithAcitvePlacements from "./Clients/ClientsWithActivePlacements";
import ClientsWithOutPlacements from "./Clients/ClientsWithoutPlacements";

const Client = () => {
  const ClientMenus = [
    {
      title: "All Clients",
      page: <AllClients />,
      type: "main",
    },

    {
      title: "Clients with Active Placements",
      page: <ClientsWithAcitvePlacements />,
      type: "main",
      // disabled: true,
    },
    {
      title: "Clients without Placements",
      page: <ClientsWithOutPlacements />,
      type: "main",
      // disabled: true,
    },
    {
      title: "Add Client",
      link: "/client/add-client",
      type: "sub",
      icon: "add",
    },
  ];
  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Client Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={ClientMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="client"
      />
      ;
    </>
  );
};

export default Client;
